"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactModal = require("react-modal");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _videoReact = require("video-react");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

var _reactSlick = require("react-slick");

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstaModal = function InstaModal(props) {
  var closeModal = function closeModal() {
    props.handleCloseModal();
  };

  var slider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidestoshow: 1,
    slidestoscroll: 1,
    arrows: true,
    variableWidth: true,
    rows: 1,
    autoplay: false,
    swipeToSlide: false,
    draggable: false
  };

  return _react2.default.createElement(
    "section",
    { id: "modal" },
    _react2.default.createElement(
      _reactModal2.default,
      {
        isOpen: props.modalIsOpen,
        onRequestClose: closeModal,
        shouldCloseOnOverlayClick: true,
        contentLabel: "Minimal Modal Example"
      },
      _react2.default.createElement(
        "div",
        { key: props.post.id, className: "modal-file" },
        props.post.media_type === "IMAGE" && !props.post.children && _react2.default.createElement("img", { className: "post-image", src: props.post.media_url }),
        props.post.media_type === "CAROUSEL_ALBUM" && props.post.children && _react2.default.createElement(
          _reactSlick2.default,
          slider,
          props.post.children.data.map(function (child) {
            return _react2.default.createElement(
              "div",
              { key: child.id, className: "post-image__slider" },
              _react2.default.createElement(
                "div",
                { className: "post-image__container" },
                _react2.default.createElement("img", { src: child.media_url })
              )
            );
          })
        ),
        props.post.media_type === "VIDEO" && _react2.default.createElement(_videoReact.Player, {
          playsInline: true,
          poster: props.post.thumbnail_url,
          src: props.post.media_url
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "modal-data" },
        _react2.default.createElement(
          "div",
          { className: "user" },
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "p",
              null,
              props.post.username
            ),
            _react2.default.createElement(
              "p",
              { className: "caption" },
              props.post.caption
            )
          ),
          _react2.default.createElement(
            "a",
            { href: props.post.permalink, className: "sn_logo", target: "_blank" },
            _react2.default.createElement(_idbReactIconlib2.default, { name: "Instagram" })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "all-comments" },
          props.post.comments && _react2.default.createElement(
            _react.Fragment,
            null,
            props.post.comments.data.map(function (comment) {
              return _react2.default.createElement(
                "div",
                { key: comment.id, className: "comment" },
                _react2.default.createElement(
                  "strong",
                  null,
                  comment.username
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  comment.text
                )
              );
            })
          )
        )
      )
    )
  );
};

exports.default = InstaModal;